import { render, staticRenderFns } from "./PromotionTargetManager.vue?vue&type=template&id=be706fe4&scoped=true"
import script from "./PromotionTargetManager.vue?vue&type=script&lang=js"
export * from "./PromotionTargetManager.vue?vue&type=script&lang=js"
import style0 from "./PromotionTargetManager.vue?vue&type=style&index=0&id=be706fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be706fe4",
  null
  
)

export default component.exports